import { render } from "./Content.vue?vue&type=template&id=2360618f&scoped=true&ts=true"
import script from "./Content.vue?vue&type=script&lang=ts"
export * from "./Content.vue?vue&type=script&lang=ts"

import "./Content.vue?vue&type=style&index=0&id=2360618f&lang=scss&scoped=true"
import "./Content.vue?vue&type=style&index=1&id=2360618f&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2360618f"]])

export default __exports__